import { useQuery } from '@tanstack/react-query';
import { FetchResult, instance } from './config';
import { AxiosResponse } from 'axios';
import { IImageListItem } from '@types';

async function getSimilarImageList(id?: number): Promise<AxiosResponse<FetchResult<IImageListItem[]>>> {
  const response = await instance.get(`/images/similarity?imageId=${id}`);
  return response;
}

const useFetchSimilarImageList = (id?: number) => {
  const { data: originalData } = useQuery({
    queryKey: ['get', `/images/similarity?imageId=${id}`],
    queryFn: () => getSimilarImageList(id),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: Boolean(id)
  });

  const data = originalData?.data.data;

  return { data };
};

export default useFetchSimilarImageList;
